import React from 'react';
import * as XLSX from 'xlsx';
import { Topic, VocabularyWord } from '../../types';

interface Props {
  isLoading: boolean;
  vocabularies: VocabularyWord[];
  selectedTopic: Topic | null;
  isAddDisabled: boolean;
  onOpenAddModal: () => void;
  onEdit: (vocab: VocabularyWord) => void;
  onDelete: (vocabId: string) => void;
  onOpenImportModal: () => void;
}

const VocabularyListPanel: React.FC<Props> = ({ isLoading, vocabularies, selectedTopic, isAddDisabled, onOpenAddModal, onEdit, onDelete, onOpenImportModal }) => {
  // --- HÀM MỚI ĐỂ TẠO VÀ TẢI FILE MẪU ---
  const handleDownloadTemplate = () => {
    // Dữ liệu mẫu với các cột cần thiết
    const sampleData = [
      {
        word: "example",
        type: "noun",
        ipa: "/ɪɡˈzɑːmp(ə)l/",
        definition: "a thing characteristic of its kind",
        example1: "This is a sample sentence.",
        example2: "Here is another example."
      },
      {
        word: "template",
        type: "noun",
        ipa: "/ˈtempleɪt/",
        definition: "a preset format",
        example1: "Please use the provided template.",
        example2: ""
      }
    ];

    // Tạo một worksheet từ mảng dữ liệu
    const worksheet = XLSX.utils.json_to_sheet(sampleData);
    // Tạo một workbook mới
    const workbook = XLSX.utils.book_new();
    // Thêm worksheet vào workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, "Vocabularies");
    // Tạo và tải xuống file excel
    XLSX.writeFile(workbook, "vocab-import-template.xlsx");
  };

  if (!selectedTopic) {
    return <div className="panel-placeholder">Select a topic to manage vocabularies.</div>;
  }

  return (
    <div className="studio-list-panel">
      <h3>Vocabularies in "{selectedTopic.name}"</h3>
      {isLoading ? <div className="loading-spinner"></div> : (
        <>
          <div className="vocab-list">
            {vocabularies.map(word => (
              <div key={word.id} className="vocab-item">
                <span>{word.word}</span>
                <div className="item-actions">
                  <button className="btn-edit" onClick={(e) => { e.stopPropagation(); onEdit(word); }}>Edit</button>
                  <button className="btn-delete" onClick={(e) => { e.stopPropagation(); onDelete(word.id); }}>&times;</button>
                </div>
              </div>
            ))}
            {vocabularies.length === 0 && <p className="panel-placeholder" style={{ marginTop: '10px' }}>No vocabularies yet.</p>}
          </div>
          <div className="panel-actions">
            <button className="btn btn-add" onClick={onOpenAddModal} disabled={isAddDisabled}>+ New Word</button>
            <button className="btn btn-secondary" onClick={onOpenImportModal} disabled={isAddDisabled}>Import Excel</button>
          </div>
          
          <div className="template-download-callout glass-effect">
            {/* Icon information */}
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line></svg>
            <span>
              Chưa có file? <a onClick={handleDownloadTemplate}>Tải file mẫu tại đây.</a>
            </span>
          </div>
        </>
      )}
    </div>
  );
};

export default VocabularyListPanel;